// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockHead__Lq78V {
  min-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__mUXVa {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__LXN4L {
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}
@media print {
  .blockContainer__LXN4L {
    background-color: transparent;
    box-shadow: none;
  }
}

.reportsTable__owK4K {
  width: 100%;
}
@media print {
  .reportsTable__owK4K {
    border: 1px solid var(--tables-primary-row-stroke);
  }
}

.reportsTableHead__aav_y {
  background: var(--tables-title-surface);
}

.reportsTableTh__oGay0 {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 15px 0;
  border-bottom: 1px solid var(--tables-title-stroke);
}

.reportsTableTd__EOMd2 {
  font-size: 14px;
  line-height: 17px;
  color: var(--tables-primary-row-text-main);
  padding: 8px 15px 8px 0;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.reportsTableTd__EOMd2:first-child {
  padding-left: 25px;
}
.reportsTableTd__EOMd2:last-child {
  padding-left: 25px;
}

.reportsTableTdDetails__qbMb_ {
  background: var(--tables-primary-row-surface-default);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
@media print {
  .reportsTableTdDetails__qbMb_ {
    border-bottom: none;
  }
}

.cellAlignCenter__erMzQ {
  text-align: center;
}

.cellAlignRight__h_kBH {
  text-align: right;
}

.arrowDetailsIcon__z7euu {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.extraBlock__SKlwW {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  cursor: pointer;
  text-transform: uppercase;
  padding: 15px 25px;
  background: var(--tables-primary-row-surface-default);
  border: none;
}
@media print {
  .extraBlock__SKlwW {
    overflow: hidden;
    height: 0;
  }
}

.arrowIcon___VTdk {
  stroke: var(--buttons-surface);
  margin-left: 5px;
  transition: all 0.3s ease-in-out;
}

.arrowTop__gcaxB {
  transform: rotate(180deg);
}

.detailsRow__dEPLi {
  display: none;
}

@media print {
  .detailsRowActiveReport__p91dY {
    display: table-row;
  }
}

.detailsRowIsOpen__mFuCi {
  display: table-row;
}

.skeletonSensorsTableItem__S09di {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/CompletionReportBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,qDAAA;EACA,mCAAA;AAzEF;AA2EE;EAJF;IAKI,6BAAA;IACA,gBAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;AAxEF;AA0EE;EAHF;IAII,kDAAA;EAvEF;AACF;;AA0EA;EACE,uCAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,uBAAA;EACA,yDAAA;AAvEF;AAyEE;EACE,kBAAA;AAvEJ;AA0EE;EACE,kBAAA;AAxEJ;;AA4EA;EACE,qDAAA;EACA,yDAAA;AAzEF;AA2EE;EAJF;IAKI,mBAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;AAxEF;;AA2EA;EACE,iBAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;AAxEF;AA0EE;EAXF;IAYI,gBAAA;IACA,SAAA;EAvEF;AACF;;AA0EA;EACE,8BAAA;EACA,gBAAA;EACA,gCAAA;AAvEF;;AA0EA;EACE,yBAAA;AAvEF;;AA0EA;EACE,aAAA;AAvEF;;AA2EE;EADF;IAEI,kBAAA;EAvEF;AACF;;AA0EA;EACE,kBAAA;AAvEF;;AA0EA;EACE,YAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockHead {\n  min-height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n\n  @media print {\n    background-color: transparent;\n    box-shadow: none;\n  }\n}\n\n.reportsTable {\n  width: 100%;\n\n  @media print {\n    border: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.reportsTableHead {\n  background: var(--tables-title-surface);\n}\n\n.reportsTableTh {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 15px 0;\n  border-bottom: 1px solid var(--tables-title-stroke);\n}\n\n.reportsTableTd {\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--tables-primary-row-text-main);\n  padding: 8px 15px 8px 0;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n\n  &:last-child {\n    padding-left: 25px;\n  }\n}\n\n.reportsTableTdDetails {\n  background: var(--tables-primary-row-surface-default);\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  @media print {\n    border-bottom: none;\n  }\n}\n\n.cellAlignCenter {\n  text-align: center;\n}\n\n.cellAlignRight {\n  text-align: right;\n}\n\n.arrowDetailsIcon {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n\n.extraBlock {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  cursor: pointer;\n  text-transform: uppercase;\n  padding: 15px 25px;\n  background: var(--tables-primary-row-surface-default);\n  border: none;\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.arrowIcon {\n  stroke: var(--buttons-surface);\n  margin-left: 5px;\n  transition: all 0.3s ease-in-out;\n}\n\n.arrowTop {\n  transform: rotate(180deg);\n}\n\n.detailsRow {\n  display: none;\n}\n\n.detailsRowActiveReport {\n  @media print {\n    display: table-row;\n  }\n}\n\n.detailsRowIsOpen {\n  display: table-row;\n}\n\n.skeletonSensorsTableItem {\n  height: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockHead": `blockHead__Lq78V`,
	"blockTitle": `blockTitle__mUXVa`,
	"blockContainer": `blockContainer__LXN4L`,
	"reportsTable": `reportsTable__owK4K`,
	"reportsTableHead": `reportsTableHead__aav_y`,
	"reportsTableTh": `reportsTableTh__oGay0`,
	"reportsTableTd": `reportsTableTd__EOMd2`,
	"reportsTableTdDetails": `reportsTableTdDetails__qbMb_`,
	"cellAlignCenter": `cellAlignCenter__erMzQ`,
	"cellAlignRight": `cellAlignRight__h_kBH`,
	"arrowDetailsIcon": `arrowDetailsIcon__z7euu`,
	"extraBlock": `extraBlock__SKlwW`,
	"arrowIcon": `arrowIcon___VTdk`,
	"arrowTop": `arrowTop__gcaxB`,
	"detailsRow": `detailsRow__dEPLi`,
	"detailsRowActiveReport": `detailsRowActiveReport__p91dY`,
	"detailsRowIsOpen": `detailsRowIsOpen__mFuCi`,
	"skeletonSensorsTableItem": `skeletonSensorsTableItem__S09di`
};
module.exports = ___CSS_LOADER_EXPORT___;
